import Layout from '@/components/layout/index.vue';
import Welcome from '@/pages/welcome/index.vue';
import Login from '@/pages/login/index.vue';
import { useLayoutStore } from '@/store';
function getProps(route) {
    return route.query;
}
// 系统生成路由
export const routers = [
    {
        path: '/login',
        component: Login,
        name: 'login',
        meta: {
            title: '登录',
        },
    },
    {
        path: '/',
        component: Layout,
        name: 'main',
        props: getProps,
        redirect: {
            name: 'welcome',
        },
        meta: {
            title: '主页',
            showOnly: true,
        },
        children: [
            {
                path: 'welcome',
                component: Welcome,
                name: 'welcome',
                meta: { title: '欢迎' },
            },
            {
                path: 'formSysMenu',
                component: () => useLayoutStore().supportColumn
                    ? import('@/pages/upms/formSysMenu/formSysColumnMenu.vue')
                    : import('@/pages/upms/formSysMenu/index.vue'),
                name: 'formSysMenu',
                meta: { title: '菜单列表' },
            },
            {
                path: 'formSysUser',
                component: () => import('@/pages/upms/formSysUser/index.vue'),
                name: 'formSysUser',
                meta: { title: '用户列表' },
            },
            {
                path: 'formSysDept',
                component: () => import('@/pages/upms/formSysDept/index.vue'),
                name: 'formSysDept',
                meta: { title: '机构列表' },
            },
            {
                path: 'formSysRole',
                component: () => import('@/pages/upms/formSysRole/index.vue'),
                name: 'formSysRole',
                meta: { title: '角色管理' },
            },
            {
                path: 'formSysDataPerm',
                component: () => import('@/pages/upms/formSysDataPerm/index.vue'),
                name: 'formSysDataPerm',
                meta: { title: '数据权限管理' },
            },
            {
                path: 'formSysPermCode',
                component: () => import('@/pages/upms/formSysPermCode/index.vue'),
                name: 'formSysPermCode',
                meta: { title: '权限字管理' },
            },
            {
                path: 'formSysPerm',
                component: () => import('@/pages/upms/formSysPerm/index.vue'),
                name: 'formSysPerm',
                meta: { title: '权限资源管理' },
            },
            {
                path: 'formSysLoginUser',
                component: () => import('@/pages/upms/formSysLoginUser/index.vue'),
                name: 'formSysLoginUser',
                meta: { title: '在线用户' },
            },
            {
                path: 'formSysDict',
                component: () => import('@/pages/upms/formSysDict/index.vue'),
                name: 'formSysDict',
                meta: { title: '字典管理' },
            },
            {
                path: 'formSysOperationLog',
                component: () => import('@/pages/upms/formSysOperationLog/index.vue'),
                name: 'formSysOperationLog',
                meta: { title: '操作日志' },
            },
            {
                path: 'formExceptionLog',
                component: () => import('@/pages/upms/formExceptionLog/index.vue'),
                name: 'formExceptionLog',
                meta: { title: '异常日志' },
            },
            //客户关系管理路由
            {
                path: 'formCustomerInfo',
                component: () => import('@/pages/crm/formCustomerInfo/index.vue'),
                name: 'formCustomerInfo',
                meta: { title: '客户' },
            },
            {
                path: 'formCustomerType',
                component: () => import('@/pages/crm/formCustomerType/index.vue'),
                name: 'formCustomerType',
                meta: { title: '客户类型' },
            },
            {
                path: 'formSupplierInfo',
                component: () => import('@/pages/crm/formSupplierInfo/index.vue'),
                name: 'formSupplierInfo',
                meta: { title: '供应商' },
            },
            {
                path: 'formCustomerContract',
                component: () => import('@/pages/crm/formCustomerContract/index.vue'),
                name: 'formCustomerContract',
                meta: { title: '客户合同' },
            },
            {
                path: 'formInvoiceTitle',
                component: () => import('@/pages/crm/formInvoiceTitle/index.vue'),
                name: 'formInvoiceTitle',
                meta: { title: '开票抬头' },
            },
            //资产管理路由
            {
                path: 'formAssetType',
                component: () => import('@/pages/ams/formAssetType/index.vue'),
                name: 'formAssetType',
                meta: { title: '资产品种' },
            },
            {
                path: 'formRegion',
                component: () => import('@/pages/ams/formRegion/index.vue'),
                name: 'formRegion',
                meta: { title: '资产区域' },
            },
            {
                path: 'formDevice',
                component: () => import('@/pages/ams/formDevice/index.vue'),
                name: 'formDevice',
                meta: { title: '区域设备' },
            },
            {
                path: 'formDeviceLog',
                component: () => import('@/pages/ams/formDeviceLog/index.vue'),
                name: 'formDeviceLog',
                meta: { title: '设备日志' },
            },
            {
                path: 'formAssetAcquisition',
                component: () => import('@/pages/ams/formAssetAcquisition/index.vue'),
                name: 'formAssetAcquisition',
                meta: { title: '购置资产' },
            },
            {
                path: 'formLeasedAssets',
                component: () => import('@/pages/ams/formLeasedAssets/index.vue'),
                name: 'formLeasedAssets',
                meta: { title: '租赁资产' },
            },
            {
                path: 'formLesseeUtilizedAssets',
                component: () => import('@/pages/ams/formLesseeUtilizedAssets/index.vue'),
                name: 'formLesseeUtilizedAssets',
                meta: { title: '提用资产(承租方)' },
            },
            {
                path: 'formLessorUtilizedAssets',
                component: () => import('@/pages/ams/formLessorUtilizedAssets/index.vue'),
                name: 'formLessorUtilizedAssets',
                meta: { title: '提用资产(出租方)' },
            },
            {
                path: 'formAssetDetails',
                component: () => import('@/pages/ams/formAssetDetails/index.vue'),
                name: 'formAssetDetails',
                meta: { title: '资产明细' },
            },
            {
                path: 'formBillInfo',
                component: () => import('@/pages/bill/formBillInfo/index.vue'),
                name: 'formBillInfo',
                meta: { title: '提单信息' },
            },
            // 404
            {
                path: '/:pathMatch(.*)*',
                component: () => import('@/pages/error/404.vue'),
                name: 'NotFound',
                meta: {
                    title: '404',
                },
            },
        ],
    },
];
